import React from 'react';
import { AlertTriangle, Syringe, Clock, Lock } from 'lucide-react';

const Rules = () => {
    return (
        <div className="py-12 container mx-auto px-6">
            <h1 className="font-display text-4xl text-center text-emerald-900 mb-4">Rules & Safety</h1>
            <p className="text-center text-gray-600 mb-12">Please read carefully to ensure a safe experience for everyone.</p>

            <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
                <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-red-500">
                    <div className="flex items-center mb-4 text-red-600">
                        <Syringe className="mr-3" />
                        <h3 className="font-bold text-xl">Vaccinations</h3>
                    </div>
                    <p className="text-gray-700">All dogs must be up to date on Rabies, DHPP, and Bordetella. Please upload proof in your profile before your first visit.</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-blue-500">
                    <div className="flex items-center mb-4 text-blue-600">
                        <Clock className="mr-3" />
                        <h3 className="font-bold text-xl">Punctuality</h3>
                    </div>
                    <p className="text-gray-700">Please remain in your car until your booked time starts. Leave promptly when your time ends to allow a buffer for the next guest.</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-yellow-500">
                    <div className="flex items-center mb-4 text-yellow-600">
                        <Lock className="mr-3" />
                        <h3 className="font-bold text-xl">Gate Safety</h3>
                    </div>
                    <p className="text-gray-700">Lock the gate from the inside immediately upon entering. Do not share the gate code with anyone else.</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-green-500">
                    <div className="flex items-center mb-4 text-green-600">
                        <AlertTriangle className="mr-3" />
                        <h3 className="font-bold text-xl">Clean Up</h3>
                    </div>
                    <p className="text-gray-700">You must pick up after your dog. Bags and bins are provided. Failure to clean up may result in a ban.</p>
                </div>
            </div>
        </div>
    );
};

export default Rules;